// Usage: node excel.js <path_to_excel_file>
// Installation: npm install xlsx moment

import * as XLSX from 'xlsx';
import moment from 'moment';

export const hindi_to_english_map: { [key: string]: string } = {
  क्र0सं0: 'serial_number',
  'बेज नं0': 'badge_number',
  पदनाम: 'rank',
  पीएनओ: 'pno_number',
  'eHRMS कोड़': 'ehrms_code',
  'कर्मी का नाम': 'name',
  'पिता का नाम': 'father_name',
  जन्मतिथि: 'date_of_birth',
  भर्तीतिथि: 'date_of_appointment',
  'भर्ती का प्रकार': 'type_of_appointment',
  लिंग: 'gender',
  जाति: 'caste',
  श्रेणी: 'category',
  शिक्षा: 'education',
  'अतिरिक्त शिक्षा': 'special_qualifications',
  'गृह जनपद': 'home_district',
  'वर्तमान नियुक्ति': 'current_position',
  'वर्तमान नियुक्ति - कार्य': 'current_posting_role',
  'वर्तमान पद पर नियुक्ति की तिथि': 'date_of_current_position',
  // 'जनपद मे पूर्व नियुक्तियां': 'previous_postings',
  'आगरा में नियुक्ति की तिथि': 'date_of_agra_posting',
  'जोन/मद में नियुक्ति तिथि': 'date_of_posting_to_zone',
  'पूर्व नियुक्ति/नियुक्तियाँ': 'previous_postings',
  दण्ड: 'punishments',
  'अन्य विवरण': 'other_details'
};

export function hindi_to_english(text: string) {
  // raise error if text not in hindi_to_english_map
  if (!hindi_to_english_map[text]) {
    throw new Error(`${text} not a valid column name. Only allowed values are ${Object.keys(hindi_to_english_map).join(', ')}`);
  }
  return hindi_to_english_map[text];
}

function tryParsingDate(text: string) {
  if (!text) {
    return null;
  }
  // Trim the text
  text = text.trim();

  const formats = ['DD-MM-YYYY', 'DD.MM.YYYY'];
  for (const fmt of formats) {
    const date = moment(text, fmt, true);
    if (date.isValid()) {
      return date.format('YYYY-MM-DD');
    }
  }
  throw new Error('Invalid date format found for' + text + '. Please use `DD-MM-YYYY` or `DD.MM.YYYY`');
}

export function ExcelToJSON(data: any) {
  const workbook = XLSX.read(data, { type: 'array' });

  // Assuming we're only dealing with the first sheet
  const sheetName = workbook.SheetNames[0];
  const xl_row_object: any = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { header: 1, raw: false });

  // Trim the headers
  const headers = xl_row_object[0].map((header: string) => header.trim());

  // Create a new object array with trimmed headers
  try {
    const trimmedData = xl_row_object.slice(1).map((row: any) => {
      const trimmedRow: any = {};
      headers.forEach((header: string, index: number) => {
        // Apply trim to each cell if it's a string
        if (typeof row[index] === 'string') {
          if (
            header === 'जन्मतिथि' ||
            header === 'भर्तीतिथि' ||
            header === 'वर्तमान पद पर नियुक्ति की तिथि' ||
            header === 'आगरा में नियुक्ति की तिथि' ||
            header === 'जोन/मद में नियुक्ति तिथि'
          )
            trimmedRow[header] = tryParsingDate(row[index]);
          else if (header === 'पीएनओ' || header === 'eHRMS कोड़' || header === 'क्र0सं0') trimmedRow[header] = parseInt(row[index].trim());
          else trimmedRow[header] = row[index].trim();
        } else trimmedRow[header] = row[index];

        // Convert Hindi headers to English

        try {
          trimmedRow[hindi_to_english(header)] = trimmedRow[header];
          delete trimmedRow[header];
        } catch (e) {
          console.log('Invalid conversion:', e);
          throw new Error(`${e}`);
        }
      });
      return trimmedRow;
    });
    return trimmedData;
  } catch (e) {
    throw new Error(`Error in reading excel: ${e}`);
  }
}
